import { styled, useTheme } from "styled-components";
import Header from "../components/Header.component";
import { RootContainer } from "../styles/Container.style";
import { Column } from "../styles/Utils";

export default function LoadingPage() {
  const theme = useTheme();
  return (
    <RootContainer $background={theme.color.primaryExtraLight} $topSafe={true}>
      <ColumnOvl $alignItem="center">
        <Header sloganImgSrc="/slogans/slogan-white.png" logoColor={theme.color.primary} />
      </ColumnOvl>
      <Images src="/dog-hand.gif" />
    </RootContainer>
  );
}

const ColumnOvl = styled(Column)`
  position: relative;
  z-index: 2;
`;

const Images = styled.img`
  position: absolute;
  left: 0;
  top: 10%;
  width: 100%;
  height: 90%;
  object-fit: cover;
  object-position: bottom;
  transform: rotateZ(180deg);
`;
